import axios from "axios";
import { Base_URL } from "../url";
export const fetchAttendance = async (params) => {
  const res = await axios.get(
    `${Base_URL}/PayrollAttendance/ViewDailyAttendance`,
    {
      params,
    },
  );
  return res.data;
};

export const fetchWorkingMonths = async (orgId) => {
  const res = await axios.get(
    `${Base_URL}/Attendance/GetWorkindDaysForAttendance/${orgId}`,
  );
  return res.data;
};

export const exportAttendance = async (params) => {
  const res = await axios.get(
    `${Base_URL}/PayrollAttendance/ExportDailyAttendance`,
    { params },
  );
  return res.data;
};

export const fetchResources = async (orgId) => {
  const res = await axios.get(
    `${Base_URL}/Resource/GetResourcesByOrganisation/${orgId}`,
  );
  return res.data;
};

export const fetchAttendanceSummary = async (filters) => {
  const params = {
    workingDaysId: filters.workingDaysId,
  };

  if (filters.resourceId) {
    params.resourceId = filters.resourceId;
  }

  const res = await axios.get(
    `${Base_URL}/PayrollAttendance/Summary`,
    { params }
  );

  return res.data;
};


export const fetchLeaveDetailed = async (params, orgId) => {
  const res = await axios.get(
    `${Base_URL}/PayrollAttendance/ViewLeaveDetailed`,
    { params: {
      ...params,
      organisationId: orgId,
    },
   }
  );
  return res.data;
};

export const exportLeaveDetailed = async (params, orgId) => {
  const res = await axios.get(
    `${Base_URL}/PayrollAttendance/ExportLeaveDetailed`,
    { params: {
      ...params,
      organisationId: orgId,
    },
   }
  );
  return res.data;
};
